import { configureStore } from "@reduxjs/toolkit";
import quranSlice from "./sliecs/quranSlice";
import getReader from "./sliecs/getReader";

export const store = configureStore({
    reducer: {
        quranData: quranSlice,
        getReader: getReader
    }
})